// components/ChatProvider.js
"use client"
import React from 'react';
// import { BrowserRouter } from 'react-router-dom';
import ChatInterface from './ChatInterface';

export default function ChatProvider({ assistantId }) {
  return <ChatInterface assistantId={assistantId} />;
}